import { createContext } from 'react';

export const ConditionalFieldsContext = createContext<{
  disabledFields: string[];
}>({
  disabledFields: [],
});
